<template>
  <div class="info-page">
    <div class="info-index" v-loading="!init">
      <el-form class="settings-form">
        <el-form-item label="Название проекта">
          <div class="label">
            <span>{{ this.$store.state.project.name }}</span>
          </div>
        </el-form-item>
        <el-form-item label="Адрес проекта">
          <div class="label">
            <span>{{ this.$store.state.project.address }}</span>
          </div>
        </el-form-item>
        <el-form-item label="Описание  проекта">
          <div class="label">
            <span>{{ this.$store.state.project.description }}</span>
          </div>
        </el-form-item>

        <div>
          <el-form-item label="Директивный срок начала проекта">
            <span>{{ start_date || '-' }}</span>
          </el-form-item>
          <el-form-item label="Директивный срок окончания проекта">
            <span>{{ end_date || '-' }}</span>
          </el-form-item>
        </div>
        <div></div>
      </el-form>
    </div>
    <div v-if="$store.state.project.daily_plan">
      <h4 style="margin-top: 20px">Выберите месячный план</h4>
      <el-input placeholder="Поиск ..." v-model="search" class="input-search">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <div class="jobs-ul">
        <div :class="['jobs-li', {active: plan.id === ($store.state.project.plan && $store.state.project.plan.id)}]"
             v-for="(plan, index) in filteredList" :key="index" @click="applyPlan(plan)" v-show="!plan.is_not_active">
          <div class="name">
            <span style="margin-left: 10px">{{ plan.name || plan.label }}</span>
          </div>
          <i class="fas fa-chevron-right"></i>
        </div>
      </div>
    </div>

    <div>
      <h4 style="margin-top: 20px">Аналитика по планам</h4>
      <el-input placeholder="Поиск ..." v-model="search" class="input-search">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <div class="jobs-ul">
        <div :class="['jobs-li', {active: version.id === ($store.state.project.version && $store.state.project.version.id)}]"
             v-for="(version, index) in filteredAnalyticsList" :key="index" @click="applyVersion(version)" v-show="!version.is_not_active">
          <div class="name">
            <span style="margin-left: 10px">{{ version.name || version.label }}</span>
          </div>
          <i class="fas fa-chevron-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LineChart from '../../../components/Chart.js';
import dayjs from 'dayjs';
import {getPlans} from "../../../firestore/plan";
import {getVersions} from "../../../firestore/versions";
import {getPermission} from "../../../firestore/permission";
import firebase from "firebase";
import {sortPlanByDate} from "../../../utils/date";


export default {
  name: 'Index',
  components: {
    LineChart,
  },
  data() {
    return {
      datacollection: null,
      today_reports: '-',
      init: false,
      latitude: null,
      plans: [],
      versions: [],
      longitude: null,
      search: '',
      permission: null,
    };
  },
  async beforeMount() {
    this.permission = await getPermission(this.$store.state.project.id, this.$store.state.company.uid || authFirestore.currentUser.uid, null, true);
  },
  async mounted() {
    setTimeout(() => {
      document.getElementsByClassName('bm-burger-button')[0].click()
      this.init = true;
    }, 1000);

    try {
      this.plans = [{
        name: 'Директивный',
        id: null
      }, ...await getPlans(this.$store.state.project.id),]
    } catch (e) {
      console.log(e, 'e');
    }

    try {
      const versions = await getVersions(this.$store.state.project.id);
      let result = [...versions]
      if(this.permission) {
        const available_versions = this.permission.available_versions || []
        result = versions.filter(({id}) => available_versions.includes(id))
      }

      this.versions = [{
        name: 'Основной',
        id: null
      }, ...result]

    } catch (e) {
      console.log(e, 'e');
    }
  },
  methods: {
    applyVersion(version) {
      setTimeout(() => {
        document.getElementsByClassName('bm-burger-button')[0].click()
      }, 500)

      if ((this.$store.state.project.version && this.$store.state.project.version.id === version.id) || version.id === null) {
        localStorage.removeItem('version')

        return this.$store.dispatch('setProject', {
          ...this.$store.state.project,
          version: null
        });
      }

      localStorage.setItem('version', JSON.stringify(version))
      localStorage.removeItem('plan')

      this.$store.dispatch('setProject', {
        ...this.$store.state.project,
        version: {
          ...version
        },
        plan: null
      });
    },
    applyPlan(plan) {
      setTimeout(() => {
        document.getElementsByClassName('bm-burger-button')[0].click()
      }, 500)

      localStorage.removeItem('version')

      if ((this.$store.state.project.plan && this.$store.state.project.plan.id === plan.id) || plan.id === null) {
        localStorage.removeItem('plan')

        return this.$store.dispatch('setProject', {
          ...this.$store.state.project,
          version: null,
          plan: null
        });
      }

      localStorage.setItem('plan', JSON.stringify(plan))

      this.$store.dispatch('setProject', {
        ...this.$store.state.project,
        version: null,
        plan: {
          ...plan
        }
      });


    }
  },
  computed: {
    filteredList() {
      return sortPlanByDate(this.plans).filter(plan => {
        if (!plan.name) return true
        return String(plan.name).toLowerCase().includes(this.search.toLowerCase());
      });
    },
    filteredAnalyticsList() {
      return this.versions.filter(version => {
        if (!version.name) return true
        return String(version.name).toLowerCase().includes(this.search.toLowerCase());
      });
    },
    start_date() {
      const start_date = this.$store.state.project && this.$store.state.project.start_date;
      return dayjs(start_date).format('YYYY') === '1970' ? null : start_date;
    },
    end_date() {
      const end_date = this.$store.state.project && this.$store.state.project.end_date;
      return dayjs(end_date).format('YYYY') === '1970' ? null : end_date;
    }
  },
};
</script>

<style scoped lang="scss">
.info-page {
  max-width: 600px;
  margin: 0 auto;
  padding: 5px 20px;
  border-radius: 5px;
  padding-bottom: 100px;

  .info-index {
    background: #f2f2f2;
    padding: 5px 20px;
  }
}
</style>
<style lang="scss">
.vww__day-bar span {
  font-size: 14px;
  font-weight: 500;
}

.info-page .el-form-item {
  flex-direction: column;
  display: flex;
}

.info-page .el-form-item__content {
  text-align: left;
}

.info-page .el-form-item__label {
  text-align: left;
}


.jobs-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .jobs-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 0 12px;

    &.active {
      background: rgba(54, 118, 203, 0.2);

      &:hover {
        background: rgba(196, 77, 86, 0.2);;
      }
    }

    color: #000;
    text-decoration: none !important;

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Info/Index.vue